import { createContext, useContext } from 'react';
import type { YjsRegistry } from '../yjs-registry';

export const YjsRegistryContext = createContext<YjsRegistry | null>(null);

export function useYjsRegistry(): YjsRegistry {
  const r = useContext(YjsRegistryContext);
  if (!r) throw new Error('useYjsRegistry: YjsRegistryContext provider missing');
  return r;
}
